import { Image } from "shared/components/atoms/Image";
import { FreeFortuneResultContent } from "shared/types";
import { uniqBy } from "lodash";

interface Props {
  freeFortuneResultContents: FreeFortuneResultContent[];
  className?: string;
}

export const InnerResult = ({
  freeFortuneResultContents,
  className,
}: Props) => {
  // 鑑定項目として見出しアイテムのみを抽出する
  const fortuneIndexes = uniqBy(
    freeFortuneResultContents?.flatMap((result) =>
      result.freeFortuneItems.filter((item) => item.type === "heading_1")
    ),
    "body"
  );

  // 鑑定項目（見出し）ごとにタロットカードの結果がぶら下がるように整形する
  const resultGroups = fortuneIndexes.map((fortuneIndex) => {
    const results = freeFortuneResultContents.map((result) => {
      const heading = result.freeFortuneItems.find(
        (item) =>
          item.type === fortuneIndex.type && item.body === fortuneIndex.body
      );
      const text = result.freeFortuneItems.find(
        (item) => item.order === heading.order + 1
      );

      return {
        tarotName: result.tarotName,
        tarotImageUrl: result.tarotImageUrl,
        text: text.body,
      };
    });

    return {
      title: fortuneIndex.body,
      results,
    };
  });

  return (
    <section tw="text-center" className={className}>
      <p
        tw="font-brush text-[26px] tracking-[.24px] leading-8 text-grape"
        css={{ transform: "rotate(-4deg)" }}
      >
        Result
      </p>
      <h2 tw="font-bold text-[28px] tracking-[.2px]">鑑定結果</h2>
      <ol>
        {resultGroups.map((resultGroup, index) => (
          <li key={resultGroup.title} tw="mt-10">
            <p tw="font-bold text-[28px] tracking-[.2px] text-[#F8E3FF]">
              0{index + 1}
            </p>
            <h3 tw="font-bold text-[19px] tracking-[.14px] leading-7 mt-0.5">
              {resultGroup.title}
            </h3>
            <ul>
              {resultGroup.results.map((result) => (
                <li key={`${resultGroup.title}-${result.tarotName}`}>
                  <Image
                    src={result.tarotImageUrl}
                    width={97}
                    height={180}
                    alt={`タロットカードの「${result.tarotName}」`}
                    layout="fixed"
                    tw="mt-4"
                  />
                  <h4 tw="font-bold text-[13px] tracking-[.09px] mt-2.5 bg-[#F8E3FF] p-0.5 inline">
                    {result.tarotName}のカードを選んだあなたは
                  </h4>
                  <p tw="font-medium text-xs tracking-[.16px] leading-6 whitespace-pre-wrap mt-4 text-left">
                    {result.text}
                  </p>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
    </section>
  );
};
